export const getIsServerSide = () => typeof window === 'undefined';
